import React from 'react';
import  { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import auth from './actions/auth';

/* Components */
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import MainBox from './components/MainBox/MainBox';

/* Pages */
import Index from './pages/Index/Index';
import Payment from './pages/Payment/Payment';
import PaymentChange from './pages/PaymentChange/PaymentChange';
import CreditCard from './pages/Payment/PaymentMethods/CreditCard';
import OneClick from './pages/Payment/PaymentMethods/OneClick';
import Boleto from './pages/Payment/PaymentMethods/Boleto';
import Pix from './pages/Payment/PaymentMethods/Pix';
import Dashboard from './pages/Dashboard/Dashboard';
import Plan from './pages/Plan/Plan';
import PlanChange from './pages/PlanChange/PlanChange';
import Login from './pages/Login/Login';
import LoginMember from './pages/Login/LoginMember';
import Register from './pages/Register/Register';
import PasswordRecovery from './pages/PasswordRecovery/PasswordRecovery';
import PasswordChange from './pages/PasswordChange/PasswordChange';
import AppContextProvider from './AppContext';
import Steps from './components/Steps/Steps';import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-TMLJGR3'
}

TagManager.initialize(tagManagerArgs)

function App() {

  const PrivateRoute = ({component: Component, ...rest})  => (
    <Route {...rest} render = { props => 
        auth.hasToken() ? 
            (<Component {...props}/>) 
            : (<Redirect to={{pathname: '/'}} />)
    } />
  );

  return (
    <AppContextProvider>
      <BrowserRouter>
        <div className="content">
          <div className="content-background">
            <Header />

            <div className="MainBox"> 

              <Steps />        
              
              <MainBox>
                  <Switch>
                    <Route exact path="/" component={Index} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/register" component={Register} />
                    <Route exact path="/password-recovery" component={PasswordRecovery} />
                    <Route exact path="/password-change" component={PasswordChange} />
                    <Route exact path="/payment" component={Payment} />
                    <Route exact path="/payment/credit-card" component={CreditCard} />
                    <Route exact path="/payment/boleto" component={Boleto} />
                    <Route exact path="/payment/pix" component={Pix} />
                    <Route exact path="/payment/one-click" component={OneClick} />
                    <Route exact path="/login/login-member" component={LoginMember} />

                    <PrivateRoute exact path="/payment/one-click" component={OneClick} />
                    <PrivateRoute exact path="/dashboard" component={Dashboard} />
                    <PrivateRoute exact path="/dashboard/plan" component={Plan} />
                    <PrivateRoute exact path="/dashboard/plan/payment-change" component={PaymentChange} />
                    <PrivateRoute exact path="/dashboard/plan/change" component={PlanChange} />
                  </Switch>
              </MainBox>
            </div>
          </div>
        </div>
        <Footer />

      </BrowserRouter>
    </AppContextProvider>
  )

}

export default App;
